module.exports = __webpack_public_path__ + "img/46_ProLAbel_PA6 .fc20d406.png";